import type { HubProfile } from "@roqeet/core";
import { hubClient } from "../platform/hub/index.js";
import { identity } from "./identity.js";

export { hubClient };

interface GoogleRedirectHub {
  getGoogleLoginUrl(redirectTo?: string): string;
}

function getGoogleRedirectHub(): GoogleRedirectHub | null {
  const maybeHub = hubClient as Partial<GoogleRedirectHub>;
  return typeof maybeHub.getGoogleLoginUrl === "function" ? maybeHub as GoogleRedirectHub : null;
}

/**
 * Start RoQeet Hub login.
 *
 * API-backed Hub login uses the Hub API Google OAuth redirect. The legacy
 * Supabase adapter still exchanges a basic local Google id_token. Google Drive
 * sync remains a separate opt-in feature and is not part of Hub login.
 */
export async function signInToHub(): Promise<HubProfile> {
  if (!hubClient.isConfigured()) {
    throw new Error("RoQeet Hub backend is not configured.");
  }

  const redirectHub = getGoogleRedirectHub();
  if (redirectHub) {
    globalThis.location?.assign(redirectHub.getGoogleLoginUrl(globalThis.location.href));
    return new Promise(() => {});
  }

  let idToken = identity.getIdToken();
  if (!idToken) {
    await identity.connectGoogle();
    idToken = identity.getIdToken();
  }
  if (!idToken) {
    throw new Error("Google id_token is required for the legacy Hub login path.");
  }
  return hubClient.signIn(idToken);
}

/** End the Hub session only. Local data and any separate Google Drive connection are unaffected. */
export async function signOutFromHub(): Promise<void> {
  await hubClient.signOut();
}
